document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-card-stage]').forEach(stage=>{
    const card=stage.querySelector('[data-card]');
    const scene=stage.querySelector('.card-scene');
    let current=-8,target=-8,velocity=0,startX=0,startTarget=-8,lastX=0,lastTime=0,dragging=false,raf=0;
    const render=()=>{
      if(!dragging){target+=velocity;velocity*=.92;if(Math.abs(velocity)<.01)velocity=0}
      current+=(target-current)*(dragging?.3:.16);
      const tilt=Math.max(-5,Math.min(5,Math.sin(current*Math.PI/180)*3));
      card.style.transform=`rotateX(${tilt}deg) rotateY(${current}deg)`;
      if(dragging||Math.abs(target-current)>.02||Math.abs(velocity)>.01){raf=requestAnimationFrame(render)}else{raf=0}
    };
    const wake=()=>{if(!raf)raf=requestAnimationFrame(render)};
    const begin=e=>{
      dragging=true;velocity=0;startX=e.clientX;lastX=e.clientX;startTarget=target;lastTime=performance.now();
      scene.classList.add('is-dragging');scene.setPointerCapture?.(e.pointerId);wake();e.preventDefault();
    };
    const move=e=>{
      if(!dragging)return;
      const now=performance.now(),dx=e.clientX-lastX,dt=Math.max(8,now-lastTime);
      target=startTarget+(e.clientX-startX)*.42;velocity=(dx/dt)*7;lastX=e.clientX;lastTime=now;wake();
    };
    const end=e=>{if(!dragging)return;dragging=false;scene.classList.remove('is-dragging');scene.releasePointerCapture?.(e.pointerId);wake()};
    scene.addEventListener('pointerdown',begin,{passive:false});scene.addEventListener('pointermove',move,{passive:false});scene.addEventListener('pointerup',end);scene.addEventListener('pointercancel',end);scene.addEventListener('lostpointercapture',()=>{dragging=false;scene.classList.remove('is-dragging');wake()});
    stage.querySelectorAll('[data-card-side]').forEach(btn=>btn.addEventListener('click',()=>{velocity=0;target=btn.dataset.cardSide==='back'?180:0;wake()}));
    wake();
  });
});
